<div
  class="screen-only cycle-navigation"
  *ngIf="cycleId$ | async as cycleId"
  data-test="cycle-navigation"
>
  <nav
    mat-tab-nav-bar
    [mat-stretch-tabs]="false"
    [tabPanel]="tabPanel"
    color="accent"
    *ngIf="!!cycleId"
  >
    <a mat-tab-link [routerLink]="['/cycle', cycleId]" [active]="isGeneral$ | async">
      {{ 'cycle.navigation.general' | translate }}
    </a>

    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'orders']" [active]="isOrders$ | async">
      {{ 'cycle.navigation.orders' | translate }}
    </a>

    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'section']" [active]="isSection$ | async">{{
      'cycle.navigation.section' | translate
    }}</a>

    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'arrivals']" [active]="isArrivals$ | async">
      {{ 'cycle.navigation.arrivals' | translate }}
    </a>

    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'movements']" [active]="isMovements$ | async">
      {{ 'cycle.navigation.movements' | translate }}
    </a>

    <a
      mat-tab-link
      [routerLink]="['/cycle', cycleId, 'departures']"
      [active]="isDepartures$ | async"
    >
      {{ 'cycle.navigation.departures' | translate }}
    </a>

    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'reports']" [active]="isReports$ | async">
      {{ 'cycle.navigation.reports' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
